import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import {  Spin, Row, Col } from 'antd'
import transitions from 'gl-transitions' // 动画库
import createTransition from 'gl-transition'
import createTexture from 'gl-texture2d'
import { bindActionCreators } from 'redux'
import { formatTime } from '../../../utils'
import { handleTrasitionData, calculateSize, screenShot, handleZoomImageBase64 } from '../../../utils/transition'
import { modifyCurrentTime } from '../../../redux/reducers/timeLine'
import { addFieldsValueSingle, setCanvasPlaying, setConvertIng, addTrasitionData } from '../../../redux/reducers/createVideo'

import './index.less'

interface SecondVideoProps {
	id: string;
	key: string;
	sort: string;
	st_fileurl: string;
	st_text_title: string;
	st_thumbnail: string;
	st_type: string;
	status: string;
	type: string;
}
interface TextInfoProps {
	font: string;
	fontcolor: string;
	fontsize: number;
	position: string;
	text: string;
	y: number;
}
interface LogoProps {
	st_fileurl: string;
}
interface TailVideoProps {
	st_guide_copy: TextInfoProps;
	st_brand: TextInfoProps;
	st_logo: LogoProps;
	st_slogan: TextInfoProps;
}
interface CoverProps {
	type: string;
	st_fileurl: string;
}
interface FieldsValueProps {
	st_second_vedio: SecondVideoProps[];
	st_cover: CoverProps;
	st_is_acoustic: string;
	st_tail_vedio: TailVideoProps;
	st_fileurl: string;
}
export interface CanvasPreviewProps {
	canvasWidth: number;
	canvasHeight: number;
	wrapHeight: number;
	from: string;
	currentPreview: string;
	currentTime: number;
	playing: boolean;
	convertIng: boolean;
	fieldsValue: FieldsValueProps;
	st_glsl: string;
	st_music: string;
	currentTimeChangeFrom: string;
	actions: any;
}
interface ResultProps {
	dom: HTMLImageElement;
	height: number;
	index: number;
	playStartTime: number;
	playTime: number;
	preview: boolean;
	time: number;
	transition: string;
	type: string;
	width: number;
}
interface TrasitionDataProps {
	result: ResultProps[];
	duration: number;
}
interface ZoomImageBase64Props {
	playHeight: number;
	playWidth: number;
	imgDom: HTMLImageElement;
	imageHeight: number;
	imageWidth: number;
}
interface ImageCanvasDataProps {
	imgDom: HTMLImageElement;
	endX?: number;
	sx?: number;
	sy?: number;
	x: number;
	y?: number;
	w?: number;
	h?: number;
	imageWidth?: number;
	imageHeight?: number;
	px?: number;
	py?: number;
	pw?: number;
	ph?: number;
}
const endFrameInitStyle= {
	logoStyle: {},
	guideStyle: {},
	sloganStyle: {},
	brandStyle: {}
}
const endFrameDrawStyle= {
	logoStyle: {
		animation: 'logo 0.3s ease-out',
		animationFillMode: 'forwards'
	},
	brandStyle: {
		animation: 'brand 0.3s ease-out',
		animationFillMode: 'forwards'
	},
	sloganStyle: {
		animation: 'slogan 0.3s ease-out',
		animationFillMode: 'forwards'
	},
	guideStyle: {
		animation: 'guide 0.3s ease-out',
		animationFillMode: 'forwards'
	}
}
let canvasPlaying = false
const CanvasPreview: React.FC<CanvasPreviewProps> = (props) => {
	const {
		fieldsValue,
		canvasWidth,
		canvasHeight,
		from,
		currentTime,
		playing,
		currentPreview,
		convertIng,
		currentTimeChangeFrom,
		st_glsl,
		st_music,
	} = props
	const {
		st_cover,
		st_second_vedio,
		st_is_acoustic,
		st_tail_vedio,
		st_fileurl,
	} = fieldsValue
	const isFromEditor = from === 'videoEditor'
	const isImageUpdateCanvas = st_second_vedio && st_second_vedio.length === 1 && fieldsValue.st_second_vedio[0].type === '图片'
	const [endFrameStyle, setEndFrameStyle] = useState(endFrameInitStyle)
	const [endFramePlaying, setendFramePlaying] = useState<boolean>(false)
	const [newAudio, setNewAudio] = useState(null)
	const [trasitionData, setTrasitionData] = useState([])
	const [duration, setDuration] = useState(0)
	const [loading, setLoading] = useState(false)
	const [canvasPause,setCanvasPause] = useState(null)
	const [imageCanvasData,setImageCanvasData] = useState<ImageCanvasDataProps>({imgDom: null, endX: 0, sx: 0, sy: 0, x: 0, y: 0, w: 0, h: 0, imageWidth: 0, imageHeight: 0, px: 0, py: 0, pw: 0, ph: 0})
	let interval = null
	const zoomCalculate = (totalTime, time, sx, sy, x, y, w, h, imageWidth, imageHeight) => {
		let cSx= 0, cSy= 0, cSwidth= 0, cSheight= 0
		if(totalTime <= 5000 || totalTime  > 10000) {
			// 大=>小
			cSx = sx - time * x / 100
			cSy = sy - time * y / 100
			cSwidth = imageWidth - sx * 2 + time * w / 100
			cSheight = imageHeight - sy * 2 + time * h / 100
			// console.log('大=>小',totalTime,time,cSx,cSy,cSwidth,cSheight)
		} else {
			// 小=>大
			cSx = x * time / 100
			cSy = time * y / 100
			cSwidth = imageWidth - time * w / 100
			cSheight = imageHeight - time * h / 100
			// console.log('小=>大',totalTime,time,cSx,cSy,cSwidth,cSheight)
		}
		return {cSx,cSy,cSwidth,cSheight}
	}
	// 暂停尾帧
	const canvasTailVideo = (ctx, time) => {
		const newVideo = document.createElement('video')
		newVideo.src = '//cdc-qa.elong.com/file/test-bucket/5307adc2-2514-46ef-9582-5fe4e3b93070.mp4'
		newVideo.crossOrigin = 'anonymous'
		const drawText = () => {
			ctx.font = '16px bold 黑体'
			ctx.fillStyle = '#fff'
			ctx.textAlign = 'center'
			ctx.fillText(st_tail_vedio.st_brand.text, canvasWidth/2, 140)
			ctx.fillText(st_tail_vedio.st_slogan.text, canvasWidth/2, 170)
			ctx.fillStyle= '#0d76ff'
			ctx.fillRect(canvasWidth/2 - 40, 180, 80, 30)
			ctx.fillStyle= '#fff'
			ctx.fillText(st_tail_vedio.st_guide_copy.text, canvasWidth/2, 200)
		}
		screenShot(newVideo, time, 204, 300, canvasWidth, canvasHeight).then(img => {
			ctx.drawImage(img, 0, 0, canvasWidth, canvasHeight)
			const img2 = new Image()
			img2.src = st_tail_vedio.st_logo.st_fileurl
			img2.onload = function () {
				ctx.drawImage(img2, canvasWidth/2-50, 30, 100, 100)
				drawText()
				// screenShot(newVideo, 1, 204, 300, canvasWidth, canvasHeight).then(img => {
				// 	ctx.drawImage(img, canvasWidth*(time+1), 0, canvasWidth, canvasHeight)
				// 	ctx.drawImage(img2,canvasWidth*(time+1) + (canvasWidth-30)/2, 0, 30, 30)
				// 	drawText(canvasWidth*(time+1))
				// })
			}
		})
	}
	// 暂停播放，显示对应帧的画面
	useEffect(() => {
		if(canvasPause) {
			canvasPause.setAttribute('style',`z-index: ${canvasPlaying ? 0 : 1}`)
			const ctx = canvasPause.getContext('2d')
			ctx.fillStyle='#000'
			ctx.fillRect(0,0,canvasWidth,canvasHeight)
			if(!canvasPlaying && isFromEditor) {
				if(!isImageUpdateCanvas) {
					for(let i = 0; i < trasitionData.length; i++) {
						if(currentTime >= trasitionData[i].playTime && currentTime <= trasitionData[i].playTime + trasitionData[i].time) {
							if(trasitionData[i].type === '图片') {
								if(trasitionData[i].dom) ctx.drawImage(trasitionData[i].dom, 0, 0, canvasWidth, canvasHeight)
							} else if(trasitionData[i].type === '转场') {
								if(trasitionData[i].from) ctx.drawImage(trasitionData[i].from, 0, 0, canvasWidth/2, canvasHeight)
								if(trasitionData[i].to) ctx.drawImage(trasitionData[i].to, canvasWidth/2, 0, canvasWidth, canvasHeight)
							} else if(trasitionData[i].type === '视频') {
								const newVideo = trasitionData[i].dom
								newVideo.currentTime = currentTime-trasitionData[i].playTime
								const data = calculateSize(trasitionData[i].width, trasitionData[i].height, canvasWidth, canvasHeight)
								ctx.drawImage(newVideo, data.x, data.y, data.w, data.h)
							}
							break
						} else if(currentTime > duration-2 && currentTime < duration) {
							canvasTailVideo(ctx, currentTime+2-duration)
						}
					}
				} else {
					if(st_glsl === 'zoom') {
						if(currentTime <= 15) {
							const millisecond = currentTime !== 0 ? currentTime.toFixed(1) * 1000 : 0
							const calculateTime = millisecond % (5 * 1000) === 0 ? 0 : 5000 < millisecond && millisecond < 10000 ? millisecond -5000 : millisecond > 10000 ? millisecond - 10000 : millisecond
							const  totalTime = millisecond,time = calculateTime
							const {imgDom, sx, sy, x, y, w, h, imageWidth, imageHeight, px, py, pw, ph} = imageCanvasData
							const {cSx, cSy, cSwidth, cSheight} = zoomCalculate(totalTime, time, sx, sy, x, y, w, h, imageWidth, imageHeight)
							ctx.drawImage(imgDom, cSx, cSy, cSwidth, cSheight, px, py, pw, ph)
						}else if(currentTime > 15 && currentTime <= 17) {
							// 转场
							canvasTailVideo(ctx, currentTime - 15)
						}
					} else {
						if(currentTime <= 10) {
							const {imgDom, x, endX } = imageCanvasData
							const time = currentTime !== 0 ? currentTime.toFixed(1) * 1000 : 0
							ctx.drawImage(imgDom, st_glsl === 'right_left' ? -x * time / 100 : -endX + x * time / 100, 0)
						} else if(currentTime > 10 && currentTime <= 12) {
							// 转场
							canvasTailVideo(ctx, currentTime-10)
						}
					}
				}
			}
		}
		// console.log(trasitionData,currentTime)
	},[canvasPlaying,currentTime])
	useEffect(() => {
		if(duration === 0) return
		props.actions.addFieldsValueSingle([{
			key: 'duration',
			value: duration
		}])
	}, [duration])
	// 画图
	const canvasImage = (ele, canvas2d, canvasWebgl) => () => {
		return new Promise((resolve) => {
			console.log('=====canvasImage',ele.playTime)
			canvasWebgl.setAttribute('style',`z-index: 0;`)
			if(!canvasPlaying) {
				canvas2d.setAttribute('style',`z-index: 0;`)
				resolve('')
			} else {
				canvas2d.setAttribute('style',`z-index: 1;`)
			}
			const ctx = canvas2d.getContext('2d')
			// console.log('canvasPreview canvasImage', time)
			// 图片在早已转为和canvas大小一样的 base64
			ctx.drawImage(ele.dom, 0, 0, canvasWidth, canvasHeight)
			setTimeout(() => {
				if(isFromEditor && canvasPlaying) props.actions.modifyCurrentTime({currentTime: ele.playTime+1, from: 'play'})
			},1000)
			setTimeout(() => {
				ctx.clearRect( 0, 0, canvasWidth, canvasHeight)
				if(isFromEditor && canvasPlaying) props.actions.modifyCurrentTime({currentTime: ele.playTime+2, from: 'play'})
				resolve('')
			}, ele.time * 1000)
		})
	}
	// 画视频
	const canvasVideo = (ele, canvas2d, canvasWebgl) => () => {
		return new Promise((resolve) => {
			const isVideoUrl = typeof  ele === 'string'
			canvasWebgl.setAttribute('style',`z-index: 0;`)
			if(!canvasPlaying) {
				canvas2d.setAttribute('style',`z-index: 0;`)
				resolve('')
			} else {
				canvas2d.setAttribute('style','z-index: 1')
			}
			const ctx = canvas2d.getContext('2d')
			let newVideo = null
			if(!isVideoUrl) {
				newVideo = ele.dom
			} else {
				newVideo=	document.createElement('video')
				newVideo.src = st_fileurl
			}
			newVideo.loop= false
			newVideo.preload='auto'
			if(st_is_acoustic === '1') newVideo.muted = st_is_acoustic === '1' ? true : false
			// url 开始时间为0，非url playStartTime存在，则开始时间以它为准，否则以startTime开始
			const startTime= !isVideoUrl ? ele.playStartTime ? ele.playStartTime : ele.startTime : 0
			console.log('=====newVideo.startTime', startTime)
			newVideo.currentTime= startTime
			let data = { x: 0, y: 0, w: canvasWidth, h: canvasHeight}
			if(isVideoUrl) {
				// 已有生成视频
				let flag = true
				newVideo.addEventListener('canplay', () => {
					if(flag) {
						flag = false
						data = calculateSize(newVideo.videoWidth, newVideo.videoHeight, canvasWidth, canvasHeight)
					}
				})
			} else {
				// 素材中的视频
				data = calculateSize(ele.width, ele.height, canvasWidth, canvasHeight)
			}
			newVideo.play()
			// console.log('canvasPreview','newVideo',newVideo)
			const drawCanvas= () => {
				ctx.drawImage(newVideo, data.x, data.y, data.w, data.h)
			}
			let prewTime = -1
			let currentTime = ele.playStartTime + ele.playTime
			newVideo.addEventListener('timeupdate',function(){
				if(!canvasPlaying) {
					if(newVideo) {
						newVideo.pause()
					}
					resolve('')
				}
				// 素材中的视频
				let timeDisplay = 0
				timeDisplay = Math.round(newVideo.currentTime)
				if(timeDisplay !== prewTime){
					prewTime = timeDisplay
					// console.log('=====canvasPreview','timeDisplay',timeDisplay)
					// console.log('=====newVideo.currentTime', ele.playStartTime,ele.playStartTime++)
					if(isFromEditor && canvasPlaying && !st_fileurl) {
						props.actions.modifyCurrentTime({currentTime: currentTime++, from: 'play'})
					}
				}
				// 已有生成视频
				if(isFromEditor && canvasPlaying && st_fileurl) {
					props.actions.modifyCurrentTime({currentTime: newVideo.currentTime, from: 'play'})
				}
				drawCanvas()
			},false)
			function stopDrawing() {
				ctx.clearRect( 0, 0, canvasWidth, canvasHeight)
				resolve('')
			}
			newVideo.addEventListener('ended', stopDrawing, false)
		})
	}
	// 加音频
	const createAudio = () => {
		console.log('st_music',st_music)
		if(!st_music) return
		const newAudio =document.createElement('AUDIO') as HTMLAudioElement
		newAudio.src = st_music
		newAudio.loop = false
		newAudio.autoplay = false
		setNewAudio(newAudio)
		newAudio.play()
		newAudio.addEventListener('timeupdate', function() {
			if(!canvasPlaying) {
				newAudio.pause()
			}
		})
	}
	// 加尾帧
	const createTailVideo = (canvas, time) => () => {
		return new Promise((resolve) => {
			console.log('=====createTailVideo',time)
			if(!canvasPlaying) {
				resolve('')
			}
			setendFramePlaying(true)
			const ctx = canvas.getContext('2d')
			const newVideo = document.createElement('VIDEO') as HTMLVideoElement
			newVideo.src = 'http://m.elongstatic.com/cdc/com-static/endFrame.mp4'
			newVideo.loop = false
			newVideo.preload ='auto'
			// setEndFrameStyle(endFrameInitStyle)
			let data = {
				x: 0,
				y: 0,
				w: canvasWidth,
				h: canvasHeight
			}
			newVideo.addEventListener('canplay', function () {
				data = calculateSize(this.videoWidth, this.videoHeight, canvasWidth, canvasHeight)
			})
			newVideo.play()
			ctx.clearRect(0, 0, canvasWidth, canvasHeight)

			newVideo.addEventListener('timeupdate',function(){
				const currentTime = newVideo.currentTime
				ctx.drawImage(newVideo, data.x, data.y, data.w, data.h)
				if(isFromEditor && canvasPlaying) {
					props.actions.modifyCurrentTime({currentTime: time + 1, from: 'play'})
				}
				if(Math.floor(currentTime) === 1) {
					setEndFrameStyle(endFrameDrawStyle)
				}
			})
			function stopDrawing() {
				ctx.fillRect(0, 0, canvasWidth, canvasHeight)
				ctx.fillStyle = '#020010'
				setTimeout(function(){
					if(isFromEditor && canvasPlaying) {
						props.actions.modifyCurrentTime({currentTime: time + 2, from: 'play'})
					}
					resolve('')
				},1000)
			}
			newVideo.addEventListener('ended', stopDrawing, false)
		})

	}
	// 加转场
	const createTranslate = (ele, canvas2d, canvasWebgl) => () => {
		return new Promise((resolve) => {
			console.log('=====createTranslate',ele.playTime)
			canvas2d.setAttribute('style',`z-index: 0;`)
			if(!canvasPlaying) {
				canvasWebgl.setAttribute('style',`z-index: 0;`)
				resolve('')
			} else {
				canvasWebgl.setAttribute('style',`z-index: 1;`)
			}
			const gl = canvasWebgl.getContext('webgl') || canvasWebgl.getContext('experimental-webgl')
			gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true)
			const buffer = gl.createBuffer()
			gl.bindBuffer(gl.ARRAY_BUFFER, buffer)
			gl.bufferData(
				gl.ARRAY_BUFFER,
				new Float32Array([-1, -1, -1, 4, 4, -1]), // see a-big-triangle
				gl.STATIC_DRAW
			)
			gl.viewport(0, 0, canvasWidth, canvasHeight)

			const from = createTexture(gl, ele.from)
			from.minFilter = gl.LINEAR
			from.magFilter = gl.LINEAR

			const to = createTexture(gl, ele.to)
			to.minFilter = gl.LINEAR
			to.magFilter = gl.LINEAR
			// console.log('canvasPreview','ele.from',ele.from)
			// console.log('canvasPreview','ele.to',ele.to)
			const transition = createTransition(gl, transitions.find(t => t.name === ele.transition))
			clearInterval(interval)
			transition.draw(0, from, to, canvasWidth, canvasHeight, {})
			let percentX = 0
			const step = 0.1
			// console.log('canvasPreview createTranslate', time)

			interval = setInterval(() => {
				// console.log('canvasPreview','percentX',percentX)
				transition.draw((percentX), from, to, canvasWidth, canvasHeight, {})
				percentX = percentX + step
				// console.log('canvasPreview','percentX=>',percentX,'step',step)
				if (percentX > 1) {
					percentX = 1
					transition.draw((percentX), from, to, canvasWidth, canvasHeight, {})
					if(isFromEditor && canvasPlaying) {
						props.actions.modifyCurrentTime({currentTime: ele.playTime + 1, from: 'play'})
					}
					resolve('')
					clearInterval(interval)
				}
			}, 100)
		})
	}
	// 图片+视频 || 图片+N || 视频+N 开始播放
	const mixtureUpdateCanvas= async() => {
		if(loading) return
		if(convertIng) return
		// 初始化 start
		setLoading(true)
		const trasitionData: TrasitionDataProps = await handleTrasitionData(
			!st_fileurl ? JSON.parse(JSON.stringify(st_second_vedio)) : [{ type: '视频', st_fileurl }],
			canvasWidth,
			canvasHeight,
			st_glsl,
			st_tail_vedio
		)
		const { result, duration } = trasitionData
		setTrasitionData(result)
		console.log('canvasPreview','handleTrasitionData=> init end',duration,result)
		setDuration(duration)
		setLoading(false)
		props.actions.addTrasitionData({
			from,
			data: result
		})
		// 初始化 end
		props.actions.setCanvasPlaying({
			status: true,
			from
		})
		canvasPlaying = true
		// setPlaying(true)
		const canvasWrap = document.getElementById(`canvasWrap_${from}`)
		canvasWrap.innerHTML = ''
		// 图片视频2d 转场webgl (暂时没找到方法可以同一canvas动态改变上下文环境)
		const canvas_2d = document.createElement('canvas')
		const canvas_webgl = document.createElement('canvas')
		const canvas_pause = document.createElement('canvas')
		canvas_2d.setAttribute('id',`canvas_2d`)
		canvas_webgl.setAttribute('id',`canvas_webgl`)
		canvas_pause.setAttribute('id',`canvas_pause`)
		canvas_2d.width = canvasWidth
		canvas_webgl.width = canvasWidth
		canvas_pause.width = canvasWidth
		canvas_2d.height = canvasHeight
		canvas_webgl.height = canvasHeight
		canvas_pause.height = canvasHeight
		canvasWrap.appendChild(canvas_pause)
		canvasWrap.appendChild(canvas_2d)
		canvasWrap.appendChild(canvas_webgl)
		setCanvasPause(canvas_pause)
		// 从其他时间开始播放
		const curTime = Math.round(currentTime)
		console.log('currentTime', curTime,'currentTimeChangeFrom',result,currentTimeChangeFrom)
		let time = 0
		let flag = true
		result.forEach(item => {
			if(item.transition === 'none' && item.type === '转场') {
				//
			} else {
				item.playStartTime = 0
				item.playTime = time
				time = time + item.time
				if(time < curTime) {
					item.preview = false
				} else if(time == curTime) {
					flag = false
					item.preview = false
				} else {
					item.preview = true
					if(flag) {
						console.log('=====flag','curTime-',curTime,item.playTime,curTime - item.playTime,item)
						item.playStartTime = curTime - item.playTime //计算从图片或视频第几秒开始播放
						flag = false
					}
				}
			}
		})
		console.log('=====trasitionData',result)
		// 无已生成的视频预览
		const promiseTasks = []
		result.forEach(item => {
			item.transition = st_glsl ? st_glsl : 'none'
			if(item.type === '图片' && item.preview) {
				promiseTasks.push(canvasImage(item, canvas_2d, canvas_webgl))
			} else if (item.type === '视频' && item.preview) {
				promiseTasks.push(canvasVideo(item, canvas_2d, canvas_webgl))
			} else if(item.type === '转场' && item.preview && item.transition !== 'none') {
				promiseTasks.push(createTranslate(item, canvas_2d, canvas_webgl))
			}
		})
		if(!st_fileurl) {
			//尾帧
			if(st_tail_vedio) {
				promiseTasks.push(createTailVideo(canvas_2d, duration-2))
			}
			console.log('canvasPreview','promiseTasks',promiseTasks)
			// 音频
			createAudio()
		}
		const doPromiseTasks = promiseTasks.reduce(
			(prevPromise, nextPromise) => prevPromise.then(() => nextPromise()),
			Promise.resolve()
		)
		doPromiseTasks.then(() => {
			props.actions.setCanvasPlaying({
				status: false,
				from
			})
			canvasPlaying = false
			// setPlaying(false)
			setendFramePlaying(false)
			console.log('canvasPreview','preview doPromiseTasks over', !canvasPlaying,JSON.stringify(fieldsValue) !== '{}',  JSON.stringify(fieldsValue.st_cover) !== '{}')
		}).catch(e => {
			console.log('canvasPreview',e)
		})
	}
	// 移动缩放 是否尾帧
	const imageUpdateTail = (canvas2d) => {
		if(st_tail_vedio) {
			const promiseTasks = []
			// 移动总时间10秒 ，10秒后+2尾帧，缩放15+2
			promiseTasks.push(createTailVideo(canvas2d, st_glsl === 'zoom' ? 15 : 10))
			const doPromiseTasks = promiseTasks.reduce(
				(prevPromise, nextPromise) => prevPromise.then(() => nextPromise()),
				Promise.resolve()
			)
			doPromiseTasks.then(() => {
				props.actions.setCanvasPlaying({
					status: false,
					from
				})
				canvasPlaying = false
				setendFramePlaying(false)
				console.log('canvasPreview','preview doPromiseTasks over', !canvasPlaying,JSON.stringify(fieldsValue) !== '{}',  JSON.stringify(fieldsValue.st_cover) !== '{}')
			}).catch(e => {
				console.log('canvasPreview',e)
			})
		} else {
			props.actions.setCanvasPlaying({
				status: false,
				from
			})
			canvasPlaying = false
		}
	}
	// 一张图片 开始播放
	const imageUpdateCanvas = async () => {
		if(canvasPlaying) {
			canvasPlaying = false
			props.actions.setCanvasPlaying({
				status: false,
				from
			})
			return
		}
		if(loading) return
		if(convertIng) return
		// 初始化 start
		setLoading(true)
		const imageUrl = fieldsValue.st_second_vedio[0].st_fileurl
		const zoomImageBase64: ZoomImageBase64Props = await handleZoomImageBase64(imageUrl, canvasHeight)
		const { playHeight, playWidth, imgDom, imageHeight, imageWidth } = zoomImageBase64
		// 变量声明
		const isZoom= st_glsl === 'zoom',
			playingTime = isZoom ? 5 : 10,
			playRepeat = isZoom ? 3 : 1,
			ratio= 1.2,
			canvasWrap= document.getElementById(`canvasWrap_${from}`),
			canvas2d = document.createElement('canvas'),
			canvasPause = document.createElement('canvas'),
			endX = playWidth > canvasWidth ? playWidth - canvasWidth : 0
		setDuration(playingTime*playRepeat)
		canvas2d.setAttribute('id',`canvas_2d`)
		canvasPause.setAttribute('id',`canvasPause`)
		canvas2d.setAttribute('style',`z-index: 1`)
		canvasPause.setAttribute('style',`z-index: 0`)
		console.log('imageWidth=>',imageWidth,'imageHeight=>',imageHeight,'playWidth=>',playWidth,'playHeight=>',playHeight)
		console.log('playingTime=>',playingTime,'playRepeat=>', playRepeat)
		// canvas set
		canvasWrap.innerHTML = ''
		canvas2d.width = canvasWidth
		canvas2d.height = canvasHeight
		canvasPause.width = canvasWidth
		canvasPause.height = canvasHeight
		canvasWrap.appendChild(canvas2d)
		canvasWrap.appendChild(canvasPause)
		setCanvasPause(canvasPause)
		const ctx = canvas2d.getContext('2d')
		// 状态
		setLoading(false)
		createAudio()
		// 初始化 end
		props.actions.setCanvasPlaying({
			status: true,
			from
		})
		// eslint-disable-next-line require-atomic-updates
		canvasPlaying = true
		// 左右移动
		if(!isZoom) {
			let time = currentTime !== 0 ? currentTime.toFixed(1) * 1000 : 0, timeInterval= null
			// 每100毫秒移动像素
			const x = endX / (playingTime * 1000 / 100)
			// 10s  = 1000*10 = 10000 ms
			timeInterval = setInterval(() => {
				if(time === playingTime * 1000 || !canvasPlaying) {
					// 结束
					clearInterval(timeInterval)
					ctx.clearRect(0, 0, canvasWidth, canvasHeight)
					// 播放结束是否有尾帧
					imageUpdateTail(canvas2d)
					return
				}
				time = time + 100
				// 更新时间
				if(isFromEditor && canvasPlaying) props.actions.modifyCurrentTime({currentTime: time / 1000, from: 'play'})
				if(endX === 0) {
					ctx.drawImage(imgDom, (canvasWidth - playWidth)/2 , 0)
				} else {
					ctx.drawImage(imgDom, st_glsl === 'right_left' ? -x * time / 100 : -endX + x * time / 100, 0)
				}
			},100)
			setImageCanvasData({imgDom, x, endX})
		} else {
			// 缩放 放大=》正常=》放大=》正常，三次每次5s 0-5000逐渐正常，5000-10000逐渐放大，10000-15000逐渐正常
			// 根据canvas大小自适应绘画位置和宽高（）
			const data = calculateSize(imageWidth,imageHeight,canvasWidth,canvasHeight)
			const img = new Image()
			img.src = imageUrl
			img.onload = () => {
				const sx = (imageWidth * ratio - imageWidth) / 2, sy = (imageHeight * ratio - imageHeight) / 2
				// 100毫秒为一个增幅，currentTime保留一位小数
				const millisecond = currentTime !== 0 ? currentTime.toFixed(1) * 1000 : 0
				const calculateTime = millisecond % (playingTime * 1000) === 0 ? 0 : 5000 < millisecond && millisecond < 10000 ? millisecond -5000 : millisecond > 10000 ? millisecond - 10000 : millisecond
				let totalTime = millisecond,time = calculateTime,timer = null
				// 每100毫秒，裁剪xy和宽高移动px  5s = 5000ms /100 =50
				const num = playingTime * 1000 / 100
				const x = sx / num, y = sy / num, w = (sx * 2) / num, h= (sy * 2) / num
				//
				timer = setInterval(() => {
					if(totalTime % (playingTime * 1000) === 0)  {
						time = 0
					}
					if(totalTime === playingTime * playRepeat * 1000 || !canvasPlaying) {
						clearInterval(timer)
						ctx.clearRect(0, 0, canvasWidth, canvasHeight)
						// 播放结束 是否有尾帧
						imageUpdateTail(canvas2d)
						return
					}
					totalTime = totalTime + 100
					time = time + 100
					// 更新时间
					if(isFromEditor && canvasPlaying) props.actions.modifyCurrentTime({currentTime: totalTime / 1000, from: 'play'})
					const {cSx, cSy, cSwidth, cSheight} = zoomCalculate(totalTime, time, sx, sy, x, y, w, h, imageWidth, imageHeight)
					ctx.drawImage(img, cSx, cSy, cSwidth, cSheight, data.x, data.y, data.w, data.h)
				},100)
				setImageCanvasData({imgDom: img, sx, sy, x, y, w, h, imageWidth, imageHeight, px: data.x, py: data.y, pw: data.w, ph: data.h})
			}
		}
	}
	// 开始播放
	const updateCanvas= () => {
		if(canvasPlaying) {
			canvasPlaying = false
			props.actions.setCanvasPlaying({
				status: false,
				from
			})
			return
		}
		if(isImageUpdateCanvas) {
			imageUpdateCanvas()
		} else {
			mixtureUpdateCanvas()
		}
	}
	const keydown = () => {
		document.onkeydown = (e) => {
			let currKey= 0
			currKey= e.keyCode || e.which || e.charCode //支持IE、FF
			if(currKey === 32 && canvasPlaying) {
				props.actions.setCanvasPlaying({
					status: false,
					from
				})
				canvasPlaying = false
				props.actions.modifyCurrentTime({currentTime: currentTime, from: 'spaceKey'})
			} else if(currKey === 32 && !canvasPlaying) {
				// TODO 播放 移动到播放组件
				// updateCanvas()
			}
		}
	}
	const pausePlaying = () => {
		// 点击其他区域 暂停
		if(playing) {
			canvasPlaying = playing
			props.actions.setCanvasPlaying({
				status: false,
				from
			})
		}
	}
	useEffect(() => {
		if(isFromEditor) {
			keydown()
		}
	},[props.currentTime])

	//切换转场效果
	useEffect(() => {
		if(canvasPlaying) {
			canvasPlaying = false
			updateCanvas()
		}
	},[st_glsl])

	useEffect(() => {
		if(!canvasPlaying && newAudio) {
			setTimeout(() => {
				newAudio.pause()
			}, 300)
		}
	}, [canvasPlaying])

	useEffect(() => {
		// 收到高级/调整/上一步/下一步/一键上传点击 暂停播放
		if(!playing) {
			canvasPlaying = playing
		}
	},[playing])
	return (
		<Spin tip="加载中..." spinning={loading} wrapperClassName="canvas-preview-spin">
			<div className="canvas-preview" onClick={pausePlaying} style={{width: canvasWidth, height: canvasHeight}}>
				{	((!playing && JSON.stringify(fieldsValue) !== '{}' && fieldsValue.st_cover && !isFromEditor)  || (playing && from !== currentPreview))&&
					<>
						<div className="play-wrap">
							<div className="play" onClick={() =>updateCanvas()}>{canvasPlaying}</div>
						</div>
						<div className="cover-image">
							{st_cover.type === '图片' ?
								<img src={st_cover.st_fileurl} alt="封面"/>
								:
								<video src={st_cover.st_fileurl}></video>
							}
						</div>
					</>
				}
				{	JSON.stringify(fieldsValue) !== '{}' && fieldsValue.st_tail_vedio &&
					<div className="tail-video" style={{height: canvasHeight, display: endFramePlaying ? 'block' : 'none', transform: (canvasWidth < canvasHeight || from === 'videoEditor') ? 'scale(1)' : 'scale(0.4)'}}>
						<img className="logo" alt="logo" style={{...endFrameStyle.logoStyle, marginTop: (canvasWidth < canvasHeight || from === 'videoEditor') ? '45px' : '0'}} src={st_tail_vedio.st_logo.st_fileurl}/>
						<div className="brand" style={endFrameStyle.brandStyle}>{st_tail_vedio.st_brand.text}</div>
						<div className="slogan" style={endFrameStyle.sloganStyle}>{st_tail_vedio.st_slogan.text}</div>
						<div className="guide"><span style={endFrameStyle.guideStyle}>{st_tail_vedio.st_guide_copy.text}</span></div>
					</div>
				}
				<div id={`canvasWrap_${from}`} className="canvas-wrap" style={{ width: `${canvasWidth}px`, height: `${canvasHeight}px`}} >
				</div>
			</div>
			<Row className="opt-area" style={{opacity: isFromEditor ? 1 : 0}}>
				<Col span={8} className="time">{formatTime(currentTime.toFixed(0), false)}/{formatTime(duration, false)}</Col>
				<Col span={8} className={!playing ? 'play-btn' : 'play-btn paused'}><span onClick={() =>updateCanvas()}></span></Col>
				<Col span={8} className="info"><span>{canvasWidth > canvasHeight ? '16:9' : canvasWidth < canvasHeight ? '9:16' : '1:1'}</span></Col>
			</Row>
		</Spin>
	)
}
CanvasPreview.defaultProps = {
	canvasWidth: 167,
	canvasHeight: 300,
	wrapHeight: 300,
	from: 'preview',
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({
			modifyCurrentTime,
			addFieldsValueSingle,
			setCanvasPlaying,
			setConvertIng,
			addTrasitionData
		}, dispatch)
	}
}
function mapStateToProps(state) {
	return {
		userInfo: state.baseInfo.userInfo,
		fieldsValue: state.createVideo.fieldsValue,
		playing: state.createVideo.canvasPlaying,
		currentPreview: state.createVideo.currentPreview,
		currentTime: state.timeLine.currentTime,
		currentTimeChangeFrom: state.timeLine.currentTimeChangeFrom,
		contentNameMap: state.contentType.contentNameMap,
		convertIng: state.createVideo.convertIng,
	}
}
export default connect(mapStateToProps, mapDispatchToProps)(CanvasPreview)